// NOTICE: KAPTION-INTEGRATION
// Global theme change event emitter for Chatwoot

class ThemeEventEmitter {
  constructor() {
    this.listeners = new Map();
    this.currentTheme = null;
  }

  /**
   * Emit a theme change event
   * @param {string} theme - New theme ('light', 'dark', 'auto')
   * @param {string} previousTheme - Previous theme
   * @param {string} source - Source of the change ('system', 'user', 'hotkey', etc.)
   */
  emitThemeChange(theme, previousTheme = null, source = 'unknown') {
    const event = {
      theme,
      previousTheme,
      source,
      timestamp: Date.now(),
    };

    this.currentTheme = theme;

    // Emit to all listeners
    this.listeners.forEach(callback => {
      try {
        callback(event);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error in theme change listener:', error);
      }
    });

    // Also dispatch a custom DOM event for global listening
    window.dispatchEvent(
      new CustomEvent('chatwoot-theme-changed', {
        detail: event,
      })
    );
  }

  /**
   * Add a theme change listener
   * @param {Function} callback - Callback function to receive theme changes
   * @returns {Function} Unsubscribe function
   */
  onThemeChange(callback) {
    const id = Date.now() + Math.random();
    this.listeners.set(id, callback);

    // Return unsubscribe function
    return () => {
      this.listeners.delete(id);
    };
  }

  /**
   * Get current theme
   * @returns {string|null} Current theme or null if not set
   */
  getCurrentTheme() {
    return this.currentTheme;
  }

  /**
   * Remove all listeners
   */
  removeAllListeners() {
    this.listeners.clear();
  }
}

// Create global instance
const themeEventEmitter = new ThemeEventEmitter();

// Export both the instance and the class
export default themeEventEmitter;
export { ThemeEventEmitter };
